import React from 'react';
import Sidebar from './../../components/sidebar';

const App = () => {
  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <div style={{ flex: 1, padding: '20px' }}>
        <h1>Welcome to the Dashboard</h1>
        {/* Other content */}
      </div>
    </div>
  );
};

export default App;
